<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl py-0>
			<app-card heading="Session" customClasses="mb-30">

			</app-card>
			<app-card heading="Cached Data" customClasses="mb-30">
				<v-btn @click="recreateReportingCache()" :disabled="isRecreatingReportingCache" color="info">Recreate
					reporting cache</v-btn>
				<v-btn @click="recreateOrderCache()" :disabled="isRecreatingOrderCache" color="info">Recreate order
					cache</v-btn>
				<v-btn @click="reloadCompanies()" :disabled="isReloadingCompanies" color="info">Reload companies</v-btn>
				<v-btn @click="reloadEvents()" :disabled="isReloadingEvents" color="info">Reload Events</v-btn>
				<v-btn @click="reloadGuests()" :disabled="isReloadingGuests" color="info">Reload Guests</v-btn>
				<v-btn @click="reloadRequests()" :disabled="isReloadingRequests" color="info">Reload Requests</v-btn>
				<v-progress-linear stream v-if="isRecreatingReportingCache" :value="reportingCacheProgress">
					<template v-slot:default="{ value }">
						<strong>{{ Math.ceil(value) }}%</strong>
					</template>
				</v-progress-linear>
				<v-progress-linear stream v-if="isRecreatingOrderCache" :value="orderCacheProgress"></v-progress-linear>
			</app-card>
		</v-container>
		<v-snackbar v-model="isReportingCacheRecreated" :right="true" :timeout="6000" :top="true">
			Reporting Cache successfully recreated with {{ reportingCacheItems }} items.
			<v-btn flat @click="isReportingCacheRecreated = false">
				Close
			</v-btn>
		</v-snackbar>
		<v-snackbar v-model="isOhRecreated" :right="true" :timeout="6000" :top="true">
			Order Cache successfully recreated with {{ ohCacheItems }} items.
			<v-btn flat @click="isOhRecreated = false">
				Close
			</v-btn>
		</v-snackbar>
		<v-snackbar v-model="isCompaniesReloaded" :right="true" :timeout="6000" :top="true">
			Order Cache successfully reloaded with {{ reloadedCompanyItems }} items.
			<v-btn flat @click="isCompaniesReloaded = false">
				Close
			</v-btn>
		</v-snackbar>
		<v-snackbar v-model="isEventsReloaded" :right="true" :timeout="6000" :top="true">
			Events successfully reloaded with {{ reloadedEvents }} items.
			<v-btn flat @click="isEventsReloaded = false">
				Close
			</v-btn>
		</v-snackbar>
		<v-snackbar v-model="isGuestsReloaded" :right="true" :timeout="6000" :top="true">
			Guests successfully reloaded with {{ reloadedGuests }} items.
			<v-btn flat @click="isGuestsReloaded = false">
				Close
			</v-btn>
		</v-snackbar>
		<v-snackbar v-model="isRequestsReloaded" :right="true" :timeout="6000" :top="true">
			Ticket requests successfully reloaded with {{ reloadedRequests }} items.
			<v-btn flat @click="isRequestsReloaded = false">
				Close
			</v-btn>
		</v-snackbar>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			isRecreatingReportingCache: false,
			isRecreatingOrderCache: false,
			isOhRecreated: false,
			isCompaniesReloaded: false,
			isReportingCacheRecreated: false,
			isReloadingCompanies: false,
			isEventsReloaded: false,
			isGuestsReloaded: false,
			isReloadingEvents: false,
			isReloadingGuests: false,
			isReloadingRequests: false,
			isRequestsReloaded: false,
			ohCacheItems: 0,
			reportingCacheItems: 0,
			reloadedCompanyItems: 0,
			reloadedEvents: 0,
			reloadedGuests: 0,
			reloadedRequests: 0,
			orderCacheProgress: 0,
			reportingCacheProgress: 0
		}
	},
	computed: {
		...mapGetters([
			'users'
		])
	},
	sockets: {
		'order.recreate-cache.progress': function ({ payload }) {
			this.orderCacheProgress = payload.progressPercent

			if (payload.counter < payload.totalLength) {
				this.isRecreatingOrderCache = true
			} else {
				this.isRecreatingOrderCache = false
			}
		},
		'reporting.recreate-cache.progress': function ({ payload }) {
			this.reportingCacheProgress = payload.progressPercent

			if (payload.counter < payload.totalLength) {
				this.isRecreatingReportingCache = true
			} else {
				this.isRecreatingReportingCache = false
			}
		}
	},
	methods: {
		recreateReportingCache() {
			this.$confirm(`Do you really want to recreate the Reporting cache?`, {
				color: 'warning',
				icon: 'warning',
				title: 'Warning'
			}).then(res => {
				if (res === true) {
					this.reportingCacheProgress = 0
					this.isRecreatingReportingCache = true
					this.$store.dispatch('recreateReportingCache')
						.then(res => {
							this.isRecreatingReportingCache = false
							this.isReportingCacheRecreated = true
							this.reportingCacheItems = res
						})
				}
			})
		},
		recreateOrderCache() {
			this.$confirm(`Do you really want to recreate the Order cache?`, {
				color: 'warning',
				icon: 'warning',
				title: 'Warning'
			}).then(res => {
				if (res === true) {
					this.orderCacheProgress = 0
					this.isRecreatingOrderCache = true
					this.$store.dispatch('recreateOrderCache')
						.then(res => {
							this.isRecreatingOrderCache = false
							this.ohCacheItems = res
							this.isOhRecreated = true
						})
				}
			})
		},
		reloadCompanies() {
			this.$confirm(`Do you really want to reload the companies?`, {
				color: 'warning',
				icon: 'warning',
				title: 'Warning'
			}).then(res => {
				if (res === true) {
					this.isReloadingCompanies = true
					this.$store.dispatch('reloadCompanies')
						.then(res => {
							this.isReloadingCompanies = false
							this.reloadedCompanies = res
							this.isCompaniesReloaded = true
						})
				}
			})
		},
		reloadEvents() {
			this.$confirm(`Do you really want to reload the events?`, {
				color: 'warning',
				icon: 'warning',
				title: 'Warning'
			}).then(res => {
				if (res === true) {
					this.isReloadingEvents = true
					this.$store.dispatch('reloadEvents')
						.then(res => {
							this.isReloadingEvents = false
							this.reloadedEvents = res
							this.isEventsReloaded = true
						})
				}
			})
		},
		reloadGuests() {
			this.$confirm(`Do you really want to reload the guests?`, {
				color: 'warning',
				icon: 'warning',
				title: 'Warning'
			}).then(res => {
				if (res === true) {
					this.isReloadingGuests = true
					this.$store.dispatch('reloadGuests')
						.then(res => {
							this.isReloadingGuests = false
							this.reloadedGuests = res
							this.isGuestsReloaded = true
						})
				}
			})
		},
		reloadRequests() {
			this.$confirm(`Do you really want to reload the Ticket requests?`, {
				color: 'warning',
				icon: 'warning',
				title: 'Warning'
			}).then(res => {
				if (res === true) {
					this.isReloadingRequests = true
					this.$store.dispatch('reloadTicketRequests')
						.then(res => {
							this.isReloadingRequests = false
							this.reloadedRequests = res
							this.isRequestsReloaded = true
						})
				}
			})
		}
	}
}
</script>
